export const QA_NAME_LISTING_PROFILE_APPLICANTS_RETRY = 'listingApplicantsRetry'

export const QA_NAME_LISTING_PROFILE_APPLICANTS_TABLE = 'listingApplicants'

export const LISTING_PROFILE_APPLICANTS_SKELETON_ROWS = 5

export const LISTING_APPLICANTS_PAGE_SIZE = 20

export const LISTING_APPLICANT_ACTION_OPEN = 'open'

export const LISTING_APPLICANT_COLUMN_NAME = {
  Applicant: 'identity',
  Chips: 'match_chips',
  Fit: 'match',
  Portal: 'source',
  Received: 'received',
  Stage: 'stage',
  Viewing: 'viewing',
  WaitingOn: 'waiting_on',
}

export const LISTING_APPLICANT_COLUMNS_CONFIG = {
  [LISTING_APPLICANT_COLUMN_NAME.Applicant]: {
    index: 0,
    name: LISTING_APPLICANT_COLUMN_NAME.Applicant,
    ordering_field: null,
    title: 'RentalPortal.ListingProfileApplicantsApplicantColumnKey',
    visible: true,
    width: 260,
  },
  [LISTING_APPLICANT_COLUMN_NAME.Chips]: {
    index: 3,
    name: LISTING_APPLICANT_COLUMN_NAME.Chips,
    ordering_field: null,
    title: 'RentalPortal.MatchColumnChipsKey',
    visible: true,
    width: 440,
  },
  [LISTING_APPLICANT_COLUMN_NAME.Fit]: {
    index: 2,
    name: LISTING_APPLICANT_COLUMN_NAME.Fit,
    ordering_field: null,
    title: 'RentalPortal.MatchColumnFitKey',
    visible: true,
    width: 320,
  },
  [LISTING_APPLICANT_COLUMN_NAME.Portal]: {
    index: 4,
    name: LISTING_APPLICANT_COLUMN_NAME.Portal,
    ordering_field: null,
    title: 'RentalPortal.ApplicantPortalColumnKey',
    visible: true,
    width: 200,
  },
  [LISTING_APPLICANT_COLUMN_NAME.Received]: {
    index: 5,
    name: LISTING_APPLICANT_COLUMN_NAME.Received,
    ordering_field: null,
    title: 'RentalPortal.ListingProfileApplicantsReceivedColumnKey',
    visible: true,
    width: 160,
  },
  [LISTING_APPLICANT_COLUMN_NAME.Stage]: {
    index: 1,
    name: LISTING_APPLICANT_COLUMN_NAME.Stage,
    ordering_field: null,
    title: 'RentalPortal.ListingProfileApplicantsStageColumnKey',
    visible: true,
    width: 160,
  },
  [LISTING_APPLICANT_COLUMN_NAME.Viewing]: {
    index: 7,
    name: LISTING_APPLICANT_COLUMN_NAME.Viewing,
    ordering_field: null,
    title: 'RentalPortal.ListingProfileApplicantsViewingColumnKey',
    visible: true,
    width: 180,
  },
  [LISTING_APPLICANT_COLUMN_NAME.WaitingOn]: {
    index: 6,
    name: LISTING_APPLICANT_COLUMN_NAME.WaitingOn,
    ordering_field: null,
    title: 'RentalPortal.ListingProfileApplicantsWaitingOnColumnKey',
    visible: true,
    width: 160,
  },
}

export const LISTING_APPLICANT_STAGES = {
  approved: {
    text: 'RentalPortal.ApplicantStageApprovedKey',
    textColor: 'var(--color-success)',
  },
  pool: {
    text: 'RentalPortal.ApplicantStagePoolKey',
    textColor: 'var(--color-info)',
  },
  rejected: {
    text: 'RentalPortal.ApplicantStageRejectedKey',
    textColor: 'var(--color-error)',
  },
  screening: {
    text: 'RentalPortal.ApplicantStageScreeningKey',
    textColor: 'var(--color-warning)',
  },
  selected: {
    text: 'RentalPortal.ApplicantStageSelectedKey',
    textColor: 'var(--color-success)',
  },
  withdrawn: {
    text: 'RentalPortal.ApplicantStageWithdrawnKey',
    textColor: 'var(--secondary-text-color)',
  },
}

export const LISTING_APPLICANT_ROW_ACTIONS = [
  {
    label: 'RentalPortal.ListingProfileApplicantsOpenActionOptionKey',
    permission: true,
    value: LISTING_APPLICANT_ACTION_OPEN,
  },
]

export const LISTING_APPLICANTS_STATE = {
  empty: 'empty',
  error: 'error',
  loading: 'loading',
  table: 'table',
}
